module.exports = __webpack_public_path__ + "img/l1s.920cf61d.png";